import { IGtmContext, IGtmDataLayer } from '../models/helpers/GtmDataLayerHelper';

// Teach Typescript that there can be a datalayer on the window
declare global {
	interface Window {
		dataLayer: IGtmDataLayer[];
	}
}

export class GtmDataLayerHelper<T extends IGtmContext> {
	constructor(public initDefaultContext: () => T) {
		if (!window.dataLayer) {
			window.dataLayer = [];
		}
	}

	private loadDefaultContext(data: IGtmDataLayer<Partial<T>>) {
		if (data && data.context) {
			data.context.timestamp = Date.now();
			data.context = Object.assign(data.context, this.initDefaultContext());
		}
	}

	logDataLayerEvent(data: IGtmDataLayer<Partial<T>>): void {
		this.loadDefaultContext(data);
		window.dataLayer.push(data);
	}
}
